import React from "react";
import {render} from "react-dom";
import Widget from "./component";
import {Provider} from "react-redux";
import {createStore, applyMiddleware, compose} from "redux";
import thunkMiddleware from "redux-thunk";
import {reducers} from "./reducers";

// Lazy load dialog - it's only needed when opened
const loadDialog = () => import(/* webpackChunkName: "course-details-dialog" */ './dialog');

// Create store only once - reuse if already exists
let store = window.__courseDetailsStore__ || createStore(reducers, compose(
    applyMiddleware(thunkMiddleware),
    window.devToolsExtension ? window.devToolsExtension() : f => f
));
window.__courseDetailsStore__ = store;

const courseDetailsEl = document.getElementById('course-details');
if (courseDetailsEl) {
    // Clear the spinner immediately
    courseDetailsEl.innerHTML = '';
    
    // Render Widget immediately
    render(
        <Provider store={store}>
            <Widget languageCode={languageCode}
                    marathon={marathon}
                    marathonPrice={marathonPrice}
                    miniUrl={miniUrl}
                    marathonUrl={marathonUrl}
                    basicUrl={basicUrl}
                    sevenUrl={sevenUrl}
                    miniPrice={miniPrice}
                    basePrice={basePrice}
                    baseGroupPrice={baseGroupPrice}
                    hasGroupCourse={hasGroupCourse}
                    hasIntermediate={hasIntermediate}
                    hasNativeSpeaker={hasNativeSpeaker}
                    hasMp3={hasMp3}
                    hasDicts={hasDicts}
                    exampleSeven={exampleSeven}
                    exampleBasic={exampleBasic}
            />
        </Provider>,
        courseDetailsEl
    );
    
    // Load dialog asynchronously - it's only needed when user interacts
    loadDialog().then(({ default: Dialog }) => {
        const dialogContainer = document.createElement('div');
        document.body.appendChild(dialogContainer);
        render(
            <Provider store={store}>
                <Dialog/>
            </Provider>,
            dialogContainer
        );
    });
}


// WEBPACK FOOTER //
// ./src/course_details/app.js